import { LoadingState, useProNavigate } from '@mp';
import React, { Fragment, useMemo } from 'react';
import { useOrientationJobsList } from './graphql';
import { useProRouteParams } from '@mp/hooks/useProRouteParams';
import { OrientationJobsListItem } from './OrientationJobsListItem';
import { Box, Divider, Heading, Text, VStack } from '@medely/ui-kit';
import JobDisplayHelpers from '@mp/components/jobs/jobDisplayHelpers';
import { OrientationJobsListItemJobFragment } from '@mp/graphql/generated/graphql';

const getJobTimesUniqueKey = (job: OrientationJobsListItemJobFragment) => {
  return `${job.current_starts_time}-${job.current_ends_time}-${job.starts_date}`;
};

export const OrientationJobsList = () => {
  const { navigate } = useProNavigate();
  const { poolId } = useProRouteParams<'OrientationJobsList'>('OrientationJobsList').params;
  if (!poolId) {
    navigate('Today');
    return null;
  }

  const { jobs, isLoading } = useOrientationJobsList(poolId);

  // Filter out jobs with duplicate start/end times + start dates
  const filteredJobs = useMemo(() => {
    const seenKeys = new Set<string>();
    return jobs.filter((job) => {
      const key = getJobTimesUniqueKey(job);
      if (seenKeys.has(key)) {
        return false;
      }
      seenKeys.add(key);
      return true;
    });
  }, [jobs]);

  if (isLoading) {
    return <LoadingState />;
  }
  if (!jobs.length) {
    return <div>No jobs available for this orientation.</div>;
  }

  return (
    <VStack>
      <Box mb={3}>
        <Heading size="xs">{JobDisplayHelpers.positions(jobs[0])} Pro Pool Orientation</Heading>
        <Text size="m">Select one of the available options below</Text>
      </Box>
      {filteredJobs.map((job, index) => (
        <Fragment key={`${index}-${job.id}`}>
          <OrientationJobsListItem job={job} />
          <Box my={2}>
            <Divider />
          </Box>
        </Fragment>
      ))}
    </VStack>
  );
};
